import GrupoForm from "entity/Grupo/components/GrupoForm";
import GrupoConsulta from "entity/Grupo/components/GrupoConsulta";
import BasicRoute from "components/routes/BasicRoute";

export default function RoutesMenusGrupo() {

    // console.log('RoutesMenusGrupo')
    return <>
        <BasicRoute uid='grupo' route="grupo"  element={<GrupoForm />} />
        <BasicRoute uid='consultaGrupo' route="consulta-grupo" perfilAuth='admin' menuProps={{
            text: "Grupos de Produto",
            sequence: "000005",
            iconName: "Business",
            
            parent: {
                uid: "CadastrosP",
                text: "Cadastros",
                iconName: "PlaylistAdd",
            },
        }} element={<GrupoConsulta />} />
    </>
}